import angular from 'angular';
import { MeurhSolicitacoesrescisoesService } from './solicitacoesrescisoes.service';

export const MeurhSolicitacoesrescisoesListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider) {
        const resolve = {
            'entity': [
                'MeurhSolicitacoesrescisoesService',
                '$rootScope',
                '$stateParams',
                '$state',
                '$q',
                function (
                    entityService: MeurhSolicitacoesrescisoesService,
                    $rootScope: angular.IRootScopeService & { session: any },
                    $stateParams: angular.ui.IStateParamsService,
                    $state: angular.ui.IStateService,
                    $q: angular.IQService
                ) {

                if (!$stateParams['solicitacao']) {
                    return $q<void>(() => $state.go('meurh_solicitacoesrescisoes'));
                }

                return entityService.get($stateParams['solicitacao'])
                    .then((data) => {
                        const deveRedirecionar = data.estabelecimento.estabelecimento !== $rootScope.session.entities.estabelecimento.estabelecimento;
                        if (deveRedirecionar) {
                            return $q(() => $state.go('meurh_solicitacoesrescisoes'));
                        }

                        return data;
                    })
                    .catch((error) => {
                        if (error.status === 404) {
                            return $q(() => {
                                if ($state.href('meurh_solicitacoesrescisoes_not_found', $stateParams)) {
                                    $state.go('meurh_solicitacoesrescisoes_not_found', $stateParams);
                                } else {
                                    $state.go('not_found', $stateParams);
                                }
                            });
                        }

                        return $q.reject(error);
                    });
            }]
        };

        $stateProvider
            .state('meurh_solicitacoesrescisoes', {
                url: '/solicitacoes/rescisoes?q?tipo',
                template: require('html-loader!./index/solicitacoesrescisoes.index.html'),
                controller: 'Meurh\SolicitacoesrescisoesIndexController',
                controllerAs: 'mrh_slctcsrscss_lst_cntrllr',
                reloadOnSearch: false
            })

            .state('meurh_solicitacoesrescisoes_new', {
                url: '/solicitacoes/rescisoes/new?q?tipo',
                template: require('html-loader!./new/solicitacoesrescisoes.new.html'),
                controller: 'MeurhSolicitacoesrescisoesNewController',
                controllerAs: 'mrh_slctcsrscss_frm_nw_cntrllr'
            })
            .state('meurh_solicitacoesrescisoes_show', {
                url: '/solicitacoes/rescisoes/:solicitacao?path&tipo',
                resolve,
                template: require('html-loader!./show/solicitacoesrescisoes.show.html'),
                controller: 'MeurhSolicitacoesrescisoesShowController',
                controllerAs: 'mrh_slctcsrscss_frm_shw_cntrllr'
            })
            .state('meurh_solicitacoesrescisoes_edit', {
                url: '/solicitacoes/rescisoes/:solicitacao/edit?q?tipo',
                resolve,
                template: require('html-loader!./edit/solicitacoesrescisoes.edit.html'),
                controller: 'MeurhSolicitacoesrecisoesEditController',
                controllerAs: 'mrh_slctcsrscss_frm_edit_cntrllr',
                params: {
                    diferenca_movs_existentes: false
                }
            });
    }
];
